'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _params = require('../params');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = exports.createReducer = function createReducer(_ref) {
  var _actionHandlers;

  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? (0, _params.required)() : _ref$namespace,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === undefined ? {} : _ref$initialState,
      _ref$handlers = _ref.handlers,
      handlers = _ref$handlers === undefined ? {} : _ref$handlers,
      _ref$deserialize = _ref.deserialize,
      deserialize = _ref$deserialize === undefined ? function (data) {
    return data;
  } : _ref$deserialize;

  var c = {
    FETCH: namespace + '/FETCH',
    FETCH_SUCCESS: namespace + '/FETCH_SUCCESS',
    FETCH_FAILURE: namespace + '/FETCH_FAILURE'
  };

  var defaultFetch = function defaultFetch(state) {
    return _extends({}, state, {
      status: 'fetching'
    });
  };

  var defaultFetchFailure = function defaultFetchFailure(state) {
    return _extends({}, state, {
      status: 'failed'
    });
  };

  var defaultFetchSuccess = function defaultFetchSuccess(state, _ref2) {
    var data = _ref2.data;
    return _extends({}, state, {
      status: 'fetched',
      data: Array.isArray(data) ? data.map(deserialize) : deserialize(data)
    });
  };

  var _handlers$fetch = handlers.fetch,
      fetch = _handlers$fetch === undefined ? defaultFetch : _handlers$fetch,
      _handlers$fetchSucces = handlers.fetchSuccess,
      fetchSuccess = _handlers$fetchSucces === undefined ? defaultFetchSuccess : _handlers$fetchSucces,
      _handlers$fetchFailur = handlers.fetchFailure,
      fetchFailure = _handlers$fetchFailur === undefined ? defaultFetchFailure : _handlers$fetchFailur;


  var actionHandlers = (_actionHandlers = {}, _defineProperty(_actionHandlers, c.FETCH, fetch), _defineProperty(_actionHandlers, c.FETCH_FAILURE, fetchFailure), _defineProperty(_actionHandlers, c.FETCH_SUCCESS, fetchSuccess), _actionHandlers);

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref3 = arguments[1];
    var type = _ref3.type,
        payload = _ref3.payload;

    var handler = actionHandlers[type];
    return typeof handler === 'function' ? handler(state, payload) : state;
  };
};